import { findRecursive } from '@/mm/utils.js'

export function washData_productImgText3(walkedNode) {
  const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_1', 'list')
  const colNode = findRecursive(walkedNode.list, (item) => item._type === 'widgets_rowCol2', 'list')
  if (ProNode) {
    if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
      ProNode.actions[0].config['文字设计'].unshift('self_textInput')
    }
    if (!ProNode.actions.find((item) => item === 'translate')) {
      ProNode.actions.push('translate')
    }
    colNode.isRadiuShow = true
    colNode.actions = ['design', 'hover']
  }
}
